import { render, staticRenderFns } from "./FormItemCheckBox.vue?vue&type=template&id=0cbd9746&scoped=true"
import script from "./FormItemCheckBox.vue?vue&type=script&lang=js"
export * from "./FormItemCheckBox.vue?vue&type=script&lang=js"
import style0 from "./FormItemCheckBox.vue?vue&type=style&index=0&id=0cbd9746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd9746",
  null
  
)

export default component.exports